import React, { ReactNode } from "react";
import styled from "styled-components";

interface SectionHeaderProps {
  title: string;
  rightContent?: ReactNode;
}

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const Title = styled.h1`
  /* Preserving the Bulma class styling */
  &.title {
    margin-bottom: 0 !important;
  }
`;

const RightContentContainer = styled.div`
  display: flex;
  align-items: center;
`;

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  rightContent,
}) => {
  return (
    <HeaderContainer>
      <Title className="title">{title}</Title>
      {rightContent && (
        <RightContentContainer>{rightContent}</RightContentContainer>
      )}
    </HeaderContainer>
  );
};

export default SectionHeader;
